import React, { useState } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import InputMask from 'react-input-mask';
import classNames from 'classnames';

const CertificatePhoneComponent = ({
  onSubmit,
  onClose,
  onQuestionClick,
  isSubmitting
}) => {
  const [phone, setPhone] = useState('');
  const [phoneError, setPhoneError] = useState(false);

  const isPhoneValid = () => {
    const digits = phone.replace(/\D/g, '');

    return /^380\d{9}$/.test('380' + digits);
  };

  const handleContinue = () => {
    if (isSubmitting) return;

    if (!isPhoneValid()) {
      setPhoneError(true);
      return;
    }

    const digits = phone.replace(/\D/g, '');

    onSubmit(`+380${digits}`);
  };

  return (
    <div className={styles.container}>
      <img
        src={getImageFromS3('/images/mgm/bg.png')}
        alt="background"
        className={styles.backgroundImage}
      />
      <div className={styles.content}>
        <div className={styles.header}>
          <svg
            width="20"
            height="18"
            viewBox="0 0 20 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClose}
          >
            <path
              d="M4.29675 8.59375L9.66769 13.9647C10.261 14.5579 10.261 15.5198 9.66769 16.1131C9.07444 16.7063 8.11258 16.7063 7.51932 16.1131L0.707108 9.30086C0.316583 8.91033 0.316583 8.27717 0.707107 7.88664L7.51932 1.07443C8.11258 0.481175 9.07444 0.481175 9.66769 1.07443C10.261 1.66769 10.261 2.62955 9.66769 3.22281L4.29675 8.59375Z"
              fill="white"
            />
            <rect
              x="2.78076"
              y="6.99902"
              width="17"
              height="3"
              rx="1.5"
              fill="white"
            />
          </svg>
          <div onClick={onQuestionClick}>
            Є питання?
            <svg
              width="27"
              height="21"
              viewBox="0 0 27 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1.86207 0C0.837931 0 0 0.821739 0 1.82609V16.4348L2.7931 13.6957H20.4828C21.5069 13.6957 22.3448 12.8739 22.3448 11.8696V1.82609C22.3448 0.821739 21.5069 0 20.4828 0H1.86207ZM23.2759 7.30435V11.8696C23.2759 13.4217 22.0655 14.6087 20.4828 14.6087H13.0345V16.4348C13.0345 17.4391 13.8724 18.2609 14.8966 18.2609H24.2069L27 21V9.13043C27 8.12609 26.1621 7.30435 25.1379 7.30435H23.2759Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
        <div className={styles.inputWrapperContainer}>
          <h1>Для продовження оформлення</h1>
          <h2>Введіть номер телефону для подальшої активації сертифікату.</h2>
          <div className={styles.inputContainer}>
            <div className={styles.codeContainer}>+380</div>
            <InputMask
              mask="(99) 999 99 99"
              maskChar="_"
              alwaysShowMask
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              onFocus={() => setPhoneError(false)}
              onBlur={() => setPhoneError(!isPhoneValid())}
              className={classNames(
                styles.input,
                phoneError && styles.errorInput
              )}
            >
              {(inputProps) => <input {...inputProps} type="tel" />}
            </InputMask>
            {phoneError && (
              <i className={styles.phoneErrorIcon}>
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_d_0_76)">
                    <circle cx="14" cy="10" r="10" fill="#F9524D" />
                    <path
                      d="M14.9444 5L14.7407 12.555H13.2593L13.0494 5H14.9444ZM13 14.894C13 14.5752 13.0905 14.3111 13.2716 14.1019C13.4568 13.8877 13.6996 13.7806 14 13.7806C14.3045 13.7806 14.5473 13.8877 14.7284 14.1019C14.9095 14.3111 15 14.5752 15 14.894C15 15.2029 14.9095 15.4644 14.7284 15.6787C14.5473 15.8929 14.3045 16 14 16C13.6996 16 13.4568 15.8929 13.2716 15.6787C13.0905 15.4644 13 15.2029 13 14.894Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_0_76"
                      x="0"
                      y="0"
                      width="28"
                      height="28"
                      filterUnits="userSpaceOnUse"
                      colorInterpolationFilters="sRGB"
                    >
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="4" />
                      <feGaussianBlur stdDeviation="2" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_0_76"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_0_76"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
              </i>
            )}
          </div>
          <div className={styles.errorContainer}>
            {phoneError && (
              <p className={styles.error}>
                Перевір коректність вказаного номеру
              </p>
            )}
          </div>
        </div>
        <div className={styles.buttonContainer}>
          <button
            className={styles.continueButton}
            onClick={handleContinue}
            disabled={isSubmitting}
            style={isSubmitting ? { opacity: 0.6 } : undefined}
          >
            {isSubmitting ? 'Обробка...' : 'Продовжити'}
          </button>
          <button className={styles.closeButton} onClick={onClose}>
            Закрити
          </button>
        </div>
      </div>
    </div>
  );
};

export default CertificatePhoneComponent;
